<template>
<div>
  <AppTextField v-model.trim="model.$model"
                :label="$t('common.firstName')"
                :error-messages="firstNameErrors"
                :error="isErrored"
  />
  <AppTextFieldSuggestion v-if="displaySuggestedValue"
                          :suggestedValue="suggestedValue"
                          @validate="model.$model = suggestedValue"
  />
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import AppTextFieldSuggestion from '@/common/identity-checking/AppTextFieldSuggestion.vue'
import { formFieldErrors } from '@/common/utils/form'
import { ID_CHECK_ERRORS } from '@/common/utils/idCheckErrors'

export default {
  name: 'FirstName',
  components: { AppTextField, AppTextFieldSuggestion },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('user', ['idCheckError']),
    ...mapGetters('user', ['hasIdCheckErrorInfo']),
    firstNameErrors () {
      return formFieldErrors(
        this.model,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('common.firstName') })],
        ],
      )
    },
    isErrored () {
      return this.hasIdCheckErrorInfo &&
        this.idCheckError.errors.includes(ID_CHECK_ERRORS.ERROR_FIRSTNAME_MISMATCH) &&
        this.displaySuggestedValue
    },
    suggestedValue () {
      return this.idCheckError?.suggestedValues?.firstName
    },
    displaySuggestedValue () {
      return this.suggestedValue && this.suggestedValue !== this.model.$model
    },
  },
}
</script>
